'use strict'

import HttpClient from './HttpClient'

class Quote extends HttpClient {
  shipperCreate (data) {
    var url = '/api/shipper/quote/request/job/create/new'

    return this.sendPost(url, this.headers, data)
  }
  shipperUpdateQuote (data) {
    var url = '/api/shipper/quote/request/job/update'

    return this.sendPut(url, this.headers, data)
  }
  shipperGetAllQuote () {
    var url = '/api/shipper/my/quote/request/job/get/all'

    return this.sendGet(url, this.headers)
  }
  shipperGetOneQuote (data) {
    var url = '/api/shipper/my/quote/request/job/get/one'

    return this.sendPost(url, this.headers, data)
  }
  carrierGetAllQuote (data) {
    var url = '/api/carrier/search/quote/request/job/list'

    return this.sendPost(url, this.headers, data)
  }
  carrierGetOneQuote (data) {
    var url = '/api/carrier/get/one/quote/request/job'

    return this.sendPost(url, this.headers, data)
  }
  delete (data) {
    var url = '/api/public/search/company/profile'

    return this.sendDelete(url, this.headers, data)
  }
  carrierIncreaseViewcount (data) {
    var url = '/api/carrier/update/viewcount/quote/request/job'

    return this.sendPost(url, this.headers, data)
  }
  carrierGetQuotedQuoteItem () {
    var url = '/api/carrier/get/quote/request/job/quoted'

    return this.sendGet(url, this.headers)
  }
  shipperUpdateQuoDocViewed (data) {
    var url = '/api/shipper/quote-doc/update/viewed'

    return this.sendPut(url, this.headers, data)
  }
  publicUpdateJobLog (data) {
    var url = '/api/public/update/quote/request/job/log'

    return this.sendPut(url, this.headers, data)
  }
}

export default Quote
